import { Component } from '@angular/core';

@Component({
    selector: 'app-scroller',
    templateUrl: './scroller.component.html',
    styleUrl: './scroller.component.scss',
    standalone: false
})
export class ScrollerComponent {
  messageList = [
    {
      text: 'feature.text',
    },
  ];
}
